<template>
  <div class="UserProfileHeader">
    <div v-if="isUserLoading">
      <b-spinner class="align-middle" label="Loading..."></b-spinner>
    </div>

    <b-row align-v="center" align-h="start" v-if="!isUserLoading">
      <b-col md="3">
        <img
          :src="UserData.profile_picture"
          class="img-thumbnail"
          style="object-fit:cover; border-radius: 50%; height: 100px; width: 100px"
          alt="BB - Imagen de perfil"
        />
      </b-col>
      <b-col md="3">
        <h5 class="mb-1 text-dark-black-title">
          {{ UserData.first_name + " " + UserData.last_name }}
        </h5>
        <p class="mb-1 text-light-black">
          <strong>{{ UserData.country }}</strong>
        </p>
      </b-col>
      <b-col md="3">
        <p class="mb-1 text-dark-black-title">
          Contacto
        </p>
        <p class="mb-1 text-light-black">
          {{ UserData.email }}<br />{{ UserData.phone }}
        </p>
      </b-col>
      <b-col md="3">
        <p class="mb-1 text-dark-black-title">
          Conexiones
        </p>
        <p class="mb-1 text-light-black">
          Creado: {{ UserData.created_at }}<br />Última: {{ UserData.last_login }}
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "UserProfileHeader",
  data() {
    return {
      UserData: [],
      isUserLoading: true,
    };
  },
  computed: {
    ...mapState({
      me: (state) => state.me,
      id_room_user: (state) => state.id_room_user
    }),
  },
  mounted() {
    this.getUserData();
  },
  methods: {
    ...mapActions(["GetUser"]),

    async getUserData() {
      this.isUserLoading = true;
      let form = {
        id: this.$route.params.user_id,
      };
      this.GetUser(form).then((response) => {
        if (response.code == 200) {
          this.UserData = response.data;
          this.isUserLoading = false;
        }
      });
    },
  },
};
</script>
<style scoped></style>
